import React, { PureComponent, createRef } from 'react'
import { Button, TableCell, TableRow } from '@material-ui/core'
import { hasAccess } from '../../utils/api'
import { EditableReactSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import ModalDialog from '../common/ModalDialog'
class WmDispatchEmployeeItem extends PureComponent {
  state = {
    isNew: true,
    shopId: '',
    workers: [],
    dropDownChange: false,
    currentWorkerId: null,
  }

  removeEmployeeModal = createRef()

  componentDidMount() {
    if (this.props.data && this.props.data.editMode) {
      this.props.getWorkers((workers) => this.setState({ workers }))
    }
  }

  linkWorker = () => {
    const { data = {} } = this.props
    this.props.linkWorker(data.id, this.state.currentWorkerId, () => {
      this.props.onCancel()
      this.setState({
        isNew: false,
      })
    })
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
    this.changeWorkersId(null)
    this.setState({
      dropDownChange: false,
    })
  }

  onCancel = () => {
    this.props.onCancel()
    this.changeWorkersId(null)
    this.setState({
      dropDownChange: false,
    })
  }

  removeWorker = () => {
    const { data } = this.props

    this.props.removeWorker(data.id, () => {
      this.props.onCancel()
      this.setState({
        isNew: true,
        dropDownChange: false,
        currentWorkerId: '',
      })
    })
  }

  deleteEmployee = () => {
    const { data } = this.props

    this.props.deleteEmployee(data.employeeId, () => {
      this.props.onCancel()
      this.setState({
        isNew: true,
        dropDownChange: false,
        currentWorkerId: '',
      })
    })
  }

  openRemoveEmployee = () => {
    this.removeEmployeeModal.current.handleClickOpen()
  }

  onEdit = () => {
    this.props.getWorkers((workers) => this.setState({ workers }))
    this.props.enableEdit()
  }

  filterSelectedWorker = (dispatchInfo) => {
    const info = dispatchInfo || {}
    let selectedWorker = {}
    selectedWorker = {
      value: info.externalEmployeeId || '',
      label: info.firstName != undefined ? info.firstName + ' ' + info.lastName : null,
    }

    if (dispatchInfo) {
      this.setState({ isNew: false })
    }

    if (!this.state.dropDownChange) {
      this.setState({ currentWorkerId: selectedWorker.value })
    }
    return selectedWorker
  }

  changeWorkersId = (value) => {
    this.setState({ currentWorkerId: value, dropDownChange: true })
  }

  onChangeWorkers = (worker) => {
    const { data = {} } = this.props
    let workerId = worker.value
    if (workerId === 'addWorker') {
      this.props.createNewWorker(data, (res) => {
        if (res && res.externalEmployeeId) {
          workerId = res.externalEmployeeId
          this.props.getWorkers((workers) => {
            this.setState({ workers })
            this.changeWorkersId(workerId)
          })
        }
      })
    } else {
      this.changeWorkersId(workerId)
    }
  }
  render() {
    const { data, editMode } = this.props

    const { isNew } = this.state
    const externalInfo =
      data.externalEmployeeIds &&
      data.externalEmployeeIds.length > 0 &&
      data.externalEmployeeIds.filter((e) => e.provider === 'WMDISPATCH' && !e.deleted)[0]
    const selectedWorkers = this.filterSelectedWorker(externalInfo)
    const showRemoveButton = editMode && !isNew
    const externalName = externalInfo ? externalInfo.firstName + ' ' + externalInfo.lastName : '---'

    let workersOptions = this.state.workers.map((worker) => ({
      label: worker.firstName + ' ' + worker.lastName,
      value: worker.externalEmployeeId,
    }))
    workersOptions.unshift({ label: '[Add Worker]', value: 'addWorker' })

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">{`${data.firstName} ${data.lastName}`}</TableCell>
        <TableCell className="cell-wrap-word multi-select-position">
          <EditableReactSelect
            value={this.state.currentWorkerId}
            onChange={this.onChangeWorkers}
            editMode={editMode}
            valueToRender={selectedWorkers.label || externalName}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
            options={workersOptions}
            clearable={false}
          />
        </TableCell>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.linkWorker}
              onCancel={this.onCancel.bind(this)}
              onEdit={this.onEdit.bind(this)}
              editMode={editMode}
              editTitle={isNew ? 'Link' : 'Update'}
              classButton={'primary-button margin btn-border'}
              classButtonDelete={'danger-button margin btn-border'}
            />
            {showRemoveButton ? (
              <Button className="danger-button margin btn-border" onClick={this.removeWorker}>
                Unlinked
              </Button>
            ) : null}
            {!editMode ? (
              <Button className="danger-button margin btn-border" onClick={this.openRemoveEmployee}>
                Remove
              </Button>
            ) : null}
          </TableCell>
        ) : null}
        <ModalDialog
          title={'Remove employee'}
          ref={this.removeEmployeeModal}
          onConfirm={this.deleteEmployee}
          confirmText="Confirm"
        >
          <div> Are you sure you want to remove the employee from this shop? </div>
        </ModalDialog>
      </TableRow>
    )
  }
}

export default WmDispatchEmployeeItem



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchEmployeeItem.js